import { Video, Smartphone, Handshake, Star, Users, ListChecks, Tag, Circle, Clock, CheckCircle2, XCircle } from "lucide-react";

export const typeIcon = (name = "") => {
  const n = (name || "").toLowerCase();
  if (n.includes("tournage") || n.includes("shoot")) return Video;
  if (n.includes("community") || n.includes("réseau") || n.includes("reseau")) return Smartphone;
  if (n.includes("rendez")) return Handshake;
  if (n.includes("événement") || n.includes("evenement")) return Star;
  if (n.includes("réunion") || n.includes("reunion")) return Users;
  if (n.includes("tâche") || n.includes("tache")) return ListChecks;
  return Tag;
};

export const STATUS_META = {
  todo: { label: "À faire", color: "#9CA3AF", icon: Circle },
  in_progress: { label: "En cours", color: "#F59E0B", icon: Clock },
  done: { label: "Terminé", color: "#10B981", icon: CheckCircle2 },
  cancelled: { label: "Annulé", color: "#EF4444", icon: XCircle },
};

export const PRIORITY_META = {
  urgent: { label: "Urgent", color: "#EF4444" },
  important: { label: "Important", color: "#F59E0B" },
  normal: { label: "Normal", color: "#10B981" },
};
